/**
 * 本周视频处理统计（localStorage），按自然周重置
 */
const STORAGE_KEY = 'week_report_stats_v1'

export function getIsoWeekId(d = new Date()) {
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
  const dayNum = date.getUTCDay() || 7
  date.setUTCDate(date.getUTCDate() + 4 - dayNum)
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1))
  const weekNo = Math.ceil((((date - yearStart) / 86400000) + 1) / 7)
  return `${date.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`
}

/** 本地自然周：返回该日期所在周的周一 00:00（日期部分） */
export function getMondayOfWeek(d = new Date()) {
  const date = new Date(d.getFullYear(), d.getMonth(), d.getDate())
  const day = date.getDay() || 7
  date.setDate(date.getDate() - (day - 1))
  return date
}

const LAST_WEEK_KEY = 'week_report_last_week_v1'

/** 退出登录时调用：清除本周统计等本地缓存，避免换账号复用 */
export function clearWeekReportStatsStorage() {
  try {
    localStorage.removeItem(STORAGE_KEY)
    localStorage.removeItem(LAST_WEEK_KEY)
  } catch (e) {
    void e
  }
}

export function loadWeekReportStats() {
  const weekId = getIsoWeekId()
  let raw = {}
  try {
    raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  } catch (e) {
    raw = {}
  }
  if (raw.weekId && raw.weekId !== weekId) {
    try {
      localStorage.setItem(
        LAST_WEEK_KEY,
        JSON.stringify({
          weekId: raw.weekId,
          videoCount: raw.videoCount || 0,
          timeSavedMinutes: raw.timeSavedMinutes || 0
        })
      )
    } catch (e) {
      /* ignore */
    }
    return {
      weekId,
      videoCount: 0,
      tagCounts: {},
      timeSavedMinutes: 0
    }
  }
  if (!raw.weekId) {
    return {
      weekId,
      videoCount: 0,
      tagCounts: {},
      timeSavedMinutes: 0
    }
  }
  return {
    weekId,
    videoCount: raw.videoCount || 0,
    tagCounts: raw.tagCounts && typeof raw.tagCounts === 'object' ? raw.tagCounts : {},
    timeSavedMinutes: raw.timeSavedMinutes || 0
  }
}

/** 上周快照（换周时写入），用于环比 */
export function loadLastWeekSnapshot() {
  try {
    const s = JSON.parse(localStorage.getItem(LAST_WEEK_KEY) || 'null')
    return s && typeof s === 'object' ? s : null
  } catch (e) {
    return null
  }
}

/** 当前自然周（周一至周日）展示用日期字符串 */
export function getWeekDateRangeDisplay(d = new Date()) {
  const date = new Date(d.getFullYear(), d.getMonth(), d.getDate())
  const day = date.getDay() || 7
  const monday = new Date(date)
  monday.setDate(date.getDate() - (day - 1))
  const sunday = new Date(monday)
  sunday.setDate(monday.getDate() + 6)
  const fmt = (x) =>
    `${x.getFullYear()}.${String(x.getMonth() + 1).padStart(2, '0')}.${String(x.getDate()).padStart(2, '0')}`
  return {
    start: fmt(monday),
    end: fmt(sunday),
    label: `${fmt(monday)} - ${fmt(sunday)}`
  }
}

/**
 * 视频分析成功时调用：累计条数、标签、估算节省时间（分钟）
 */
export function recordVideoProcessed(labels = [], options = {}) {
  const estimatedMinutesSaved =
    typeof options.estimatedMinutesSaved === 'number' ? options.estimatedMinutesSaved : 8
  const weekId = getIsoWeekId()
  let raw = {}
  try {
    raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  } catch (e) {
    raw = {}
  }
  if (raw.weekId !== weekId) {
    raw = { weekId, videoCount: 0, tagCounts: {}, timeSavedMinutes: 0 }
  }
  raw.videoCount = (raw.videoCount || 0) + 1
  raw.timeSavedMinutes = (raw.timeSavedMinutes || 0) + estimatedMinutesSaved
  const tagCounts = { ...(raw.tagCounts || {}) }
  ;(Array.isArray(labels) ? labels : []).forEach((tag) => {
    const t = String(tag).trim()
    if (!t) return
    tagCounts[t] = (tagCounts[t] || 0) + 1
  })
  raw.tagCounts = tagCounts
  localStorage.setItem(STORAGE_KEY, JSON.stringify(raw))
}

export function formatMinutes(totalMin) {
  const m = Math.max(0, Math.floor(totalMin || 0))
  const h = Math.floor(m / 60)
  const min = m % 60
  if (h > 0) {
    return `${h} 小时 ${min} 分钟`
  }
  return `${min} 分钟`
}

export function topTags(tagCounts, limit = 20) {
  const entries = Object.entries(tagCounts || {})
  entries.sort((a, b) => b[1] - a[1])
  return entries.slice(0, limit).map(([name, count]) => ({ name, count }))
}
